import { ProductType } from 'marketplace-ui-common/types/products';
import { useMemo } from 'react';
import { PathKey } from '../../constants/paths';
import { StorefrontBreadcrumbProps } from '../types/breadcrumbs';

const productTypeToPathKeyMap: Partial<Record<ProductType, PathKey>> = {
  APP: 'APPS',
  AGENT: 'AGENTS',
  SOLUTIONS_PARTNER_PROFILE: 'SOLUTIONS_PARTNERS',
};

type UseBreadcrumbsInput = Omit<
  StorefrontBreadcrumbProps,
  'backBreadcrumb' | 'isCurrentPage'
>;

export function useBreadcrumbs({
  pathKey,
  productType,
  slug,
  title,
}: UseBreadcrumbsInput = {}): StorefrontBreadcrumbProps[] {
  return useMemo(() => {
    const breadcrumbs: StorefrontBreadcrumbProps[] = [{ pathKey: 'HOME' }];
    const getProductTypePath = (): StorefrontBreadcrumbProps => ({
      pathKey: productTypeToPathKeyMap[productType || 'APP'] || 'APPS',
      isCurrentPage: false,
    });

    switch (pathKey) {
      case 'FEATURED_COLLECTION':
        return [
          ...breadcrumbs,
          { pathKey: 'FEATURED', isCurrentPage: false },
          {
            isCurrentPage: true,
            pathKey,
            slug,
            title,
          },
        ];

      case 'LISTING_DETAILS':
        return [
          ...breadcrumbs,
          getProductTypePath(),
          {
            isCurrentPage: true,
            pathKey,
            slug,
            title,
          },
        ];

      default:
        return [...breadcrumbs, { pathKey, isCurrentPage: true }];
    }
  }, [pathKey, productType, slug, title]);
}
